import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";

let DataModelOptions = {
	filter: '[type="x/pagedata"]'
}

class DataModel extends Class {

	constructor(element, options){
		super();
		this.element = element;
		this.setOptions(DataModelOptions, options);
		this.handleRequest();
	}

	handleRequest(){
		this.updateModel();
	}

	updateModel(){
		var script = this.element.find(this.options.filter);
		var json = script ? JSON.parse(script.html())[0] : undefined;
		this.setModel(json);
	}

	setModel(json) {
		this.model = json ? json : this.model;
	}

	getModel(){
		return this.model;
	}

}

export { DataModel };


// WEBPACK FOOTER //
// ./Javascript/core/classes/data.model.class.js